<template>
  <v-navigation-drawer v-bind="$attrs" v-on="$listeners" :value="value" @input="onInput">
    <slot></slot>
  </v-navigation-drawer>
</template>

<script>
import uuid4 from '@/utils/uuid.js';

export default {
  name: 'navigation-drawer-scroll-lock',

  props: [ 'value' ],

  created() {
    this.uuid = uuid4();
    this.$set(this.global.scrollLock, this.uuid, Boolean(this.value));
  },

  destroyed() {
    this.$delete(this.global.scrollLock, this.uuid);
  },

  methods: {
    onInput(v) {
      this.$set(this.global.scrollLock, this.uuid, v);
      this.$emit('input', v);
    }
  }
}
</script>
